<template>
  <DeepError type="page-not-found"></DeepError>
</template>

<script setup lang="ts">
import { DeepError } from '@deepcloud/deep-ui-lib'

definePage({
  name: 'sign-index',
  meta: {
    breadcrumbLabelKey: 'error.404.title',
  },
})
</script>
